import React from 'react';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import FullPageState from './components/FullPageState';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <FullPageState
          icon={<ErrorOutlineRoundedIcon fontSize="inherit" />}
          eyebrow="System notice"
          statusLabel="Application error"
          title="Something went wrong"
          description="Please try refreshing the page or contact support."
          supportingText="If the issue continues, let support know which page you were using when it occurred."
          role="alert"
          ariaLive="assertive"
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
